import { render } from "./PictureSkeleton.vue?vue&type=template&id=04005eea&scoped=true"
import script from "./PictureSkeleton.vue?vue&type=script&lang=js"
export * from "./PictureSkeleton.vue?vue&type=script&lang=js"

import "./PictureSkeleton.vue?vue&type=style&index=0&id=04005eea&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04005eea"]])

export default __exports__